import { Endpoints } from "../Endpoints";
import Backend from "../../Backend";

export default class PurchaseOrder {
  constructor(token) {
    this.backend = new Backend(token);
  }
  allStatus(callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}/purchase-status/all`, callback)
  }
  allByCreator(id, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}/creator/${id}`, callback)
  }
  allBySource(id, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}/purchase-source/${id}`, callback)
  }
  allPurchaser(id,callback){
    this.backend.callBackend(`${Endpoints.purchaseOrder.invoice}/${id}/all`, callback)
  }
  purchaserBillingaddress(id,callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.billing}/${id}/purchaser-billing-address/get-all`, callback)
  }
  purchaserPDf(id,callback){
    this.backend.callBackend(`${Endpoints.purchaseOrder.invoice}/${id}`, callback)
  }
  fundDeposite(obj,callback){
    this.backend.callBackend(`${Endpoints.purchaseOrder.invoice}/deposit`, callback,"POST",obj)
  }
  fundDepositeAdmin(obj,callback){
    this.backend.callBackend(`${Endpoints.purchaseOrder.invoice}/admin/deposit`, callback,"POST",obj)
  }
  allByPurchaseOrders(callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}/all`, callback, "GET")
  }
  allBySourceTypeId(id,pageNumber, size, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}/purchase-source-type/${id}/paging?page=${pageNumber}&size=${size}`, callback)
  }
  allbySourceTypeView(id,callback){
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}/purchase-source-type/${id}`, callback)
  }
  allGlobalsearch(id,callback){
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}/purchase-source-type/${id}/orders`,callback)
  }
  allByPurchaseSourceBySourceTypeId(purchaseSourceId, purchaseSourceTypeId,pageNumber,size, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}/purchase-source/${purchaseSourceId}/purchase-source-type/${purchaseSourceTypeId}/paging?page=${pageNumber}&size=${size}`, callback)
  }
  allByPurchaserSourceBySourceTypeIdAll(purchaseSourceId, purchaseSourceTypeId,callback){
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}/purchase-source/${purchaseSourceId}/purchase-source-type/${purchaseSourceTypeId}/orders`,callback)
  }
  purchaseOrder(id, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}/id/${id}`, callback)
  }
  purchaseOrderStatus(id, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}/purchase-status/id/${id}`, callback)
  }
  purchaseOrderDetail(id, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}/detail/order/${id}`, callback)
  }
  purchaseOrderDetailAdmin(id, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}/detail/admin/order/${id}`, callback)
  }
  purchaseOrderBatch(id,callback){
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}/${id}/batch-detail-status`,callback)
  }
  detail(id, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}/detail/${id}`, callback)
  }
  fulfillmentFile(orderName, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}/${orderName}/download`, callback)
  }
  add(data, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}`, callback, "POST", data)
  }
  addDetail(data, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}/detail`, callback, "POST", data)
  }
  updateDetail(data, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}/detail`, callback, "PUT", data)
  }
  cancelOrder(name, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}/${name}/cancel`, callback, "PATCH")
  }
  cancelAllOrder(body,callback){
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}/transaction/cancel`, callback, "POST",body)
  }
  deleteSupplierBrand(id, callback, data) {
    this.backend.callBackend(`${Endpoints.supplier.brand}/deleteSupplierBrand/${id}`, callback, "DELETE", data)
  }
  retryOrder(name, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.processing}/${name}/retry-orders`, callback, "GET")
  }
  retryAllOrder(body,callback){
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}/transaction/retry`, callback, "POST",body)
  }
  dateFilterSearch(startDate,endDate,callback){
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}/purchase-orders/all?startDate=${startDate}&endDate=${endDate}`, callback, "GET")
  }
  dateFilterSearchSpecific(startDate,endDate,id,callback){
    this.backend.callBackend(`${Endpoints.purchaseOrder.private}/purchase-orders/2/${id}?startDate=${startDate}&endDate=${endDate}`, callback, "GET")
  }
  releaseOrder(name, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.processing}/api/${name}/invoice`, callback, "GET")
  }
  releaseNonApiOrder(name, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.processing}/non-api/${name}`, callback, "GET")
  }
  downloadNonApiOrder(name, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.processing}/download/${name}`, callback, "GET")
  }
  downloadNonApiOrderForRealtime(name, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.processing}/download-realtime/${name}`, callback, "GET")
  }
  downloadIncompleteOrder(name, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.processing}/downloadCode/${name}`, callback, "GET")
  }
  downloadApiOrder(name, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.processing}/download-realtime/${name}`, callback, "GET")
  }
  downloadGetfile(name,callback){
  this.backend.callBackend(`${Endpoints.purchaseOrder.processing}/uploaded/${name}`, callback, "GET")  
  }
  downloadReplaceOrder(name,callback){
    this.backend.callBackend(`${Endpoints.purchaseOrder.processing}/download/${name}`, callback, "GET")
  }
  getHistoryBySKU(id, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.history}/${id}`, callback)
  }
  getAllHistoryBySKU(sku, from, to, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.historyAll}/${sku}/from/${from}/to/${to}`, callback)
  }

  getHistory(body,callback){
    this.backend.callBackend(`${Endpoints.purchaseOrder.orderSeacrh}/purchase-order/history`, callback, "POST", body)
  }

  getAllHistoryByCardReference({ cardReference, from, to }, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.historyAll}/reference/${cardReference}/from/${from}/to/${to}`, callback)
  }
  getPurchaseOrderHistoryBySKU(sku, startDate, endDate, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.history}/${sku}/from/${startDate}/to/${endDate}`, callback)
  }
  downloadPurchaserOrder(purchaserId, startDate, endDate, callback) {
    this.backend.callBackend(`${Endpoints.purchaseOrder.order}/${purchaserId}/startDate/${startDate}/endDate/${endDate}`, callback ,"GET")
  }
  filterDateOrders(id,startDateTwo,endDateTwo,callback){
    this.backend.callBackend(`${Endpoints.purchaseOrder.order}/filter/${id}/startDate/${startDateTwo}/endDate/${endDateTwo}`, callback ,"GET")
  }

 deleteOrder(id,callback){
  this.backend.callBackend(`${Endpoints.purchaseOrder.private}/detail/${id}`,callback,"DELETE")
 }
  getPogress(purchasername,callback){
    this.backend.callBackend(`${Endpoints.pogress.private}/${purchasername}/progress`,callback,"GET")
  }
  getProgressAPI(purchasername,callback){
    this.backend.callBackend(`${Endpoints.pogress.nonApi}/${purchasername}/progress`,callback,"GET")
  }
 modifyOrder(id,value,callback){
  this.backend.callBackend(`${Endpoints.purchaseOrder.private}/detail/${id}/${value}`,callback,"PATCH")
 }
 completeOrder(id,callback){
  this.backend.callBackend(`${Endpoints.purchaseOrder.private}/detail/${id}/complete`,callback,"POST")
 }

 failedOrder(name,callback){
  this.backend.callBackend(`${Endpoints.purchaseOrder.processing}/processFailedOrders/${name}`, callback, "POST")
 }
 approveOrder(name,callback){
  this.backend.callBackend(`${Endpoints.purchaseOrder.processing}/${name}/approve`, callback, "GET")
 }
 approveFileOrder(name,callback){
  this.backend.callBackend(`${Endpoints.purchaseOrder.processing}/uploaded/${name}/approve`, callback, "GET")
 }
 failurelog(name,callback){
  this.backend.callBackend(`${Endpoints.purchaseOrder.private}/${name}/failures`,callback,"GET")
 }

 downloadReportAdminAll(startDate,endDate,callback){
  this.backend.callBackend(`${Endpoints.purchaseOrder.private}/admin/startDate/${startDate}/endDate/${endDate}`,callback,"GET")
 }
 downloadReportAdmin(id,startDate,endDate,callback){
  this.backend.callBackend(`${Endpoints.purchaseOrder.private}/admin/${id}/startDate/${startDate}/endDate/${endDate}`,callback,"GET")
 }

}